module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "panel panel-default sortHandle"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "ac-header-" + _vm.item.id
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-1 icon"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.type === "title"),
      expression: "item.type === \"title\""
    }],
    staticClass: "fa fa-item fa-header",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.type === "text" || _vm.item.type === "name"),
      expression: "item.type === \"text\" || item.type === \"name\""
    }],
    staticClass: "fa fa-item fa-font",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.type === "textarea"),
      expression: "item.type === \"textarea\""
    }],
    staticClass: "fa fa-item fa-align-justify",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.type === "dropdown"),
      expression: "item.type === \"dropdown\""
    }],
    staticClass: "fa fa-item fa-chevron-circle-down",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.type === "checkbox"),
      expression: "item.type === \"checkbox\""
    }],
    staticClass: "fa fa-item fa-check-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.type === "radio"),
      expression: "item.type === \"radio\""
    }],
    staticClass: "fa fa-item fa-dot-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.type === "address"),
      expression: "item.type === \"address\""
    }],
    staticClass: "fa fa-item fa-home",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.type === "date"),
      expression: "item.type === \"date\""
    }],
    staticClass: "fa fa-item fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.type === "file"),
      expression: "item.type === \"file\""
    }],
    staticClass: "fa fa-item fa-clipboard",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.type === "mail"),
      expression: "item.type === \"mail\""
    }],
    staticClass: "fa fa-item fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('div', {
    staticClass: "col-xs-11 title",
    attrs: {
      "aria-controls": "collapseOne",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#" + _vm.item.id
    }
  }, [_vm._v(_vm._s(!_vm.item.caption ? '項目名を入力してください' : _vm.item.caption))])])]), _c('div', {
    staticClass: "panel-collapse collapse list-complete-item",
    attrs: {
      "id": _vm.item.id,
      "role": "tabpanel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('form', [_c('table', {
    staticClass: "form-table"
  }, [_c('tr', [_c('th', [_c('label', [_vm._v("項目名")])]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.caption),
      expression: "item.caption"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "項目名を入力してください"
    },
    domProps: {
      "value": (_vm.item.caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "caption", $event.target.value)
      }
    }
  })])]), _c('tr', [_c('th', [_c('label', [_vm._v("必須項目")])]), _c('td', [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.requiredFixed === true),
      expression: "item.requiredFixed === true"
    }],
    staticClass: "fa fa-item fa-check-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.required),
      expression: "item.required"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.item.requiredFixed === false),
      expression: "item.requiredFixed === false"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.item.required === true,
      "checked": Array.isArray(_vm.item.required) ? _vm._i(_vm.item.required, null) > -1 : (_vm.item.required)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.item.required,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.item, "required", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.item, "required", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.item, "required", $$c)
        }
      }
    }
  })])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.type === "title"),
      expression: "item.type === `title`"
    }]
  }, [_c('th', [_c('label', [_vm._v("件名入力方法")])]), _c('td', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.titleType),
      expression: "item.titleType"
    }],
    attrs: {
      "type": "radio",
      "value": "free"
    },
    domProps: {
      "checked": _vm._q(_vm.item.titleType, "free")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.item, "titleType", "free")
      }
    }
  }), _vm._v("フリー入力")]), _c('label', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.titleType),
      expression: "item.titleType"
    }],
    attrs: {
      "type": "radio",
      "value": "select"
    },
    domProps: {
      "checked": _vm._q(_vm.item.titleType, "select")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.item, "titleType", "select")
      }
    }
  }), _vm._v("選択式")])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSelect),
      expression: "showSelect"
    }]
  }, [_c('th', [_c('label', [_vm._v("選択候補")])]), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.options),
      expression: "item.options"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "placeholder": "項目1\n項目2\n項目3\nのように改行区切りで入力してください"
    },
    domProps: {
      "value": (_vm.item.options)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "options", $event.target.value)
      }
    }
  }), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOptionsFirstEmpty),
      expression: "isOptionsFirstEmpty"
    }],
    staticStyle: {
      "margin": "5px 0px 0px 5px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.optionsFirstEmpty),
      expression: "item.optionsFirstEmpty"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.item.optionsFirstEmpty === true,
      "checked": Array.isArray(_vm.item.optionsFirstEmpty) ? _vm._i(_vm.item.optionsFirstEmpty, null) > -1 : (_vm.item.optionsFirstEmpty)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.item.optionsFirstEmpty,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.item, "optionsFirstEmpty", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.item, "optionsFirstEmpty", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.item, "optionsFirstEmpty", $$c)
        }
      }
    }
  }), _vm._v("空の項目を先頭にする")])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDirection),
      expression: "showDirection"
    }]
  }, [_c('th', [_c('label', [_vm._v("配置方向")])]), _c('td', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.direction),
      expression: "item.direction"
    }],
    attrs: {
      "type": "radio",
      "value": "horizontal"
    },
    domProps: {
      "checked": _vm._q(_vm.item.direction, "horizontal")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.item, "direction", "horizontal")
      }
    }
  }), _vm._v("横")]), _c('label', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.direction),
      expression: "item.direction"
    }],
    attrs: {
      "type": "radio",
      "value": "vertical"
    },
    domProps: {
      "checked": _vm._q(_vm.item.direction, "vertical")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.item, "direction", "vertical")
      }
    }
  }), _vm._v("縦")])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.type === "date"),
      expression: "item.type === `date`"
    }]
  }, [_c('th', [_c('label', [_vm._v("日付入力種類")])]), _c('td', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.daySelectType),
      expression: "item.daySelectType"
    }],
    attrs: {
      "type": "radio",
      "value": "single"
    },
    domProps: {
      "checked": _vm._q(_vm.item.daySelectType, "single")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.item, "daySelectType", "single")
      }
    }
  }), _vm._v("日付(yyyy/mm/ddを入力します)")]), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.daySelectType),
      expression: "item.daySelectType"
    }],
    attrs: {
      "type": "radio",
      "value": "multi"
    },
    domProps: {
      "checked": _vm._q(_vm.item.daySelectType, "multi")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.item, "daySelectType", "multi")
      }
    }
  }), _vm._v("期間(yyyy/mm/dd ～ yyyy/mm/ddを入力します)")])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.type === "textarea"),
      expression: "item.type === `textarea`"
    }]
  }, [_c('th', [_c('label', [_vm._v("初期行数")])]), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.defaultLine),
      expression: "item.defaultLine"
    }],
    staticClass: "searchselect selectitems",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "入力行数を制限するものではございません"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.item, "defaultLine", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")]), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7")]), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8")]), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("9")]), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")])])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPlaceHolder),
      expression: "showPlaceHolder"
    }]
  }, [_c('th', [_c('label', [_vm._v("プレースホルダー")])]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.placeholder),
      expression: "item.placeholder"
    }],
    staticClass: "form-control placeholderinput",
    attrs: {
      "type": "text",
      "placeholder": "入力のヒント",
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "ヒントを示してユーザーの入力を補助するものです"
    },
    domProps: {
      "value": (_vm.item.placeholder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "placeholder", $event.target.value)
      }
    }
  })])]), _c('tr', [_c('th', [_c('label', [_vm._v("補足説明")])]), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.description),
      expression: "item.description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "placeholder": "入力項目の補足説明を記載できます"
    },
    domProps: {
      "value": (_vm.item.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "description", $event.target.value)
      }
    }
  })])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showWidth),
      expression: "showWidth"
    }]
  }, [_c('th', [_c('label', [_vm._v("幅指定")])]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.width),
      expression: "item.width"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "right",
      "display": "inline",
      "width": "25%"
    },
    attrs: {
      "type": "number",
      "name": "size",
      "min": "1"
    },
    domProps: {
      "value": (_vm.item.width)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "width", $event.target.value)
      }
    }
  }), _c('span', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("px")])])])])]), _c('p', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.deletable),
      expression: "item.deletable"
    }],
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("削除")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-771b9b0c","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/form/part/ItemDetail.vue
// module id = 607
// module chunks = 1